import { Callout } from '@/components/Callout/Callout'

export interface ReadOnlyCalloutProps {
  reason: string | null
}

const REASON_COPY: Record<string, string> = {
  refined_transcript_missing:
    "The production transcript for this meeting isn't available yet, so there is no consensus to prefill.",
  owner_not_reported: 'Meetings from non-Wispr accounts can be annotated only after their owner reports them.',
  owner_not_found: "This meeting's owner account could not be found.",
}

const DEFAULT_COPY = "This meeting isn't available for annotation right now."

export const ReadOnlyCallout = ({ reason }: ReadOnlyCalloutProps) => (
  <Callout.Root>
    <Callout.Header>
      <Callout.Title>Read-only</Callout.Title>
    </Callout.Header>
    <Callout.Description>{(reason && REASON_COPY[reason]) || reason || DEFAULT_COPY}</Callout.Description>
  </Callout.Root>
)
